export const MaintenanceActionTypes = {
  MATCHING_LIVE: "MATCHING_LIVE",
  MATCHING_OFFICIAL: "MATCHING_OFFICIAL",
  UPDATE_DEMO: "UPDATE_DEMO",
  CANCEL_CERTIFICATES: "CANCEL_CERTIFICATES",
  CANCEL_CERTIFICATES_AND_REPLAY_LIVE: "CANCEL_CERTIFICATES_AND_REPLAY_LIVE",
  CANCEL_CERTIFICATES_AND_REPLAY_OFFICIAL: "CANCEL_CERTIFICATES_AND_REPLAY_OFFICIAL",
  INCREMENTAL_MATCHING_OFFICIAL: "INCREMENTAL_MATCHING_OFFICIAL",
  DAILY_OFFICIAL_CERTIFICATE_GENERATION: "DAILY_OFFICIAL_CERTIFICATE_GENERATION",
  DAILY_LIVE_CERTIFICATE_GENERATION: "DAILY_LIVE_CERTIFICATE_GENERATION"
}



// WEBPACK FOOTER //
// ./src/enums/MaintenanceActionTypes.js